import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRecRearrangeStops extends Layout {
    labelDragStopsToRearrangeThem: Label;
    sourceStopRecOrder: DataSource;
    tableStop: Table;
}
